import { TYPE_MODAL } from '../../../shared/utils/constants';

const validate = (values) => {
  const errors = {};
  if (!values.type) {
    if (!values.name) {
      errors.name = 'Esse campo não pode ficar vazio';
    }
    if (!values.schoolTerm) {
      errors.schoolTerm = 'Esse campo não pode ficar vazio';
    }
    if (!values.stepQuantity) {
      errors.stepQuantity = 'Esse campo não pode ficar vazio';
    }
    if (values.stepQuantity && parseInt(values.stepQuantity, 10) < 1) {
      errors.stepQuantity = 'O valor deve ser maior que 0';
    }
    if (values.calendarCycles && !values.calendarCycles.length) {
      errors.calendarCycles = 'Gere os ciclos';
    }
    if (values.calendarCycles && values.calendarCycles.length) {
      const { calendarCycles } = values;
      if (
        !calendarCycles.every(
          (cycle) => cycle.beginInMilli !== null || cycle.endInMilli !== null
        )
      ) {
        errors.calendarCycles = 'Informe as datas dos ciclos';
      }
    }
  }
  if (values.type) {
    if (!values.name) {
      errors.name = 'Esse campo não pode ficar vazio';
    }
    if (values.type !== TYPE_MODAL.MARKING) {
      if (!values.title) {
        errors.title = 'Esse campo não pode ficar vazio';
      }
      if (!values.beginInMilli) {
        errors.beginInMilli = 'Esse campo não pode ficar vazio';
      }
      if (!values.endInMilli) {
        errors.endInMilli = 'Esse campo não pode ficar vazio';
      }
      if (!values.marker) {
        errors.marker = 'Esse campo não pode ficar vazio';
      }
    }
  }
  return errors;
};
export default validate;
